module.exports = __webpack_public_path__ + "img/de73092.jpg";